export { default as TourWidget } from './widget/TourWidget'
export { default as TourPlugin } from './plugin/TourPlugin'

export const TourIntro = props => props.children
TourIntro.displayName = 'TourIntro'

export const TourSteps = props => props.children
TourSteps.displayName = 'TourSteps'

export const TourStep = props => props.children
TourStep.displayName = 'TourStep'

export const TourSummary = props => props.children
TourSummary.displayName = 'TourSummary'
